import * as React from 'react'
import { View, Animated, TouchableOpacity } from 'react-native'
import styled from '@theme/styled-components'
import theme from '@theme/Theme'

import Icon from '@components/icon/Icons'

interface Props {
  header?: (open: boolean) => JSX.Element
  children?: JSX.Element
  open: boolean
  onOpen: () => void
}

const CollapsableCard = ({ header, children, open, onOpen }: Props) => {
  const anim = React.useMemo(() => new Animated.Value(0), [])

  React.useEffect(() => {
    if (open) {
      Animated.timing(anim, { toValue: 1, duration: 300, useNativeDriver: true }).start()
    } else {
      Animated.timing(anim, { toValue: 0, duration: 300, useNativeDriver: true }).start()
    }
  }, [open])

  const rotate = anim.interpolate({ inputRange: [0, 1], outputRange: ['0deg', '180deg'] })

  return (
    <Card>
      <HeaderContainer activeOpacity={1} onPress={onOpen}>
        <HeaderContent>{header && header(open)}</HeaderContent>
        <HeaderIcon style={{ transform: [{ rotate }] }}>
          <Icon name="arrow-down" size={15} color={theme.colors.secondaryText} />
        </HeaderIcon>
      </HeaderContainer>

      {open && <View>{children}</View>}
    </Card>
  )
}

export default CollapsableCard

const Card = styled(View)`
  background-color: ${(props) => props.theme.colors.background};
  border-radius: 8px;
`

const HeaderContainer = styled(TouchableOpacity)`
  flex-direction: row;
  align-items: center;
`

const HeaderContent = styled(View)`
  flex: 1;
`

const HeaderIcon = styled(Animated.View)`
  padding: 20px;
`
